import { getSwatchUrlByProductCode } from './ImageUtil';
import { IconName } from '@as/cotopaxi';
export const generateSwatchFromProductColor = (productColor, selectedProductColor, productCode, productCdnDomains) => ({
    colourId: Number(productColor.colourId),
    color: productColor.description,
    extendedRange: productColor.extendedRange,
    swatch: getSwatchUrlByProductCode(productCode, productColor.swatch, productCdnDomains),
    selected: selectedProductColor && Number(selectedProductColor.colourId) === Number(productColor.colourId),
    hasDiscount: productColor.hasDiscount,
    hasPermanentDiscount: productColor.markdown,
});
export const generateSwatchFromProductColorVariation = (productColorVariation, selectedColorId, productCode, productCdnDomains) => ({
    colourId: productColorVariation.colorId,
    color: productColorVariation.translations.description,
    extendedRange: productColorVariation.webOnly,
    swatch: getSwatchUrlByProductCode(productCode, productColorVariation.swatch, productCdnDomains),
    selected: selectedColorId === productColorVariation.colorId,
    hasDiscount: Boolean(productColorVariation.hasDiscount),
    hasPermanentDiscount: Boolean(productColorVariation.markdown),
    outOfStock: productColorVariation.availability === 0,
});
export const getDiscountIconContent = (productSwatch, swatchInformation) => {
    let iconContent = '';
    if (productSwatch.hasDiscount) {
        iconContent = swatchInformation.actionLabel;
        if (productSwatch.hasPermanentDiscount || productSwatch.markdown) {
            iconContent = swatchInformation.saleLabel;
        }
    }
    return iconContent;
};
export const getExtendedRangeIcon = (isShopLanding, extendedRange) => isShopLanding && extendedRange ? IconName.EXCLAMATION_CIRCLE_SOLID : undefined;
